export default [
  {
    key: "validate.custom",
    calculateValue(context) {
      return "valid = (!input && !component.validate.required) || (input && JSON.parse(input).valid) || 'Invalid Video'";
    },
  },
  {
    weight: 20,
    type: "textfield",
    input: true,
    key: "customOptions.maxVideoLength",
    label: "Max allowed video length (in seconds)",
    tooltip: "Configure with at least 1 second on top of client requirements.",
  },
  {
    weight: 20,
    type: "checkbox",
    input: true,
    key: "customOptions.closedCaptionsRequired",
    label: "Closed Captions",
    tooltip: "Select to require Closed Captions for video validation.",
  },
];
